import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { UserAccountState } from './state';

const getters: GetterTree<UserAccountState, RootState> = {
  studentEmail: (state, getters) => {
    return state.email;
  },

  studentEmailHasAccounts: (state, getters) => {
    return state.studentEmailHasAccounts;
  },
};

export default getters;
